// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hCHid","tabsBox":"styles_tabsBox__1aE_s","createButton":"styles_createButton__3Yun9"};